import {Injectable} from '@angular/core';
import {APIService} from "./api.service";
import {IUploadImageToAzure} from "../interfaces/IUploadImageToAzure";
import {GameThemeType} from "../enum/GameThemeType";
import {AppConfigService} from "./app-config.service";

@Injectable({
  providedIn: 'root'
})
export class AssetManagementService {

  public qrCodeImage: File | null = null;
  public qrCodeImageUrl: string | ArrayBuffer | null = null;
  public QrCodeImageName = 'qrcode.png';

  public gameLogoImage: File | null = null;
  public gameLogoUrl: string = '';
  public gameLogoImageName = "game-logo.svg";

  public toolbarColor = '#222222';
  public iconColor = '#ffffff';

  constructor(private appConfigService: AppConfigService,
              private apiService: APIService) { }

  public checkForExistingQrCodeImage(subdomainP: string) {
    const cdnUrl = `${this.appConfigService.cdnRoot()}/assets/${subdomainP}`;
    const qrCodeUrl = cdnUrl + '/' + this.QrCodeImageName;

    if (this.qrCodeImage) {
      // we still have the qr code selected, display this as the cdn might not have refreshed yet.
      const reader = new FileReader();
      reader.readAsDataURL(this.qrCodeImage);
      reader.onload = () => {
        this.qrCodeImageUrl = reader.result as string;
      };
    }

    const qrCodeValid = this.validateImage(qrCodeUrl);
    const combined = Promise.all([qrCodeValid]);
    combined.then(([validQrCode]) => {
      if (validQrCode) {
        this.qrCodeImageUrl = qrCodeUrl;
      }
    })
  }

  public checkForExistingGameLogo(subdomainP: string) {
    const cdnUrl = `${this.appConfigService.cdnRoot()}/assets/${subdomainP}`;
    const gameLogoUrl = cdnUrl + '/' + this.gameLogoImageName;

    if (this.gameLogoImage) {
      // we still have the logo selected, display this as the cdn might not have refreshed yet.
      const reader = new FileReader();
      reader.readAsDataURL(this.gameLogoImage);
      reader.onload = () => {
        this.qrCodeImageUrl = reader.result;
      };
    }

    const logoValid = this.validateImage(gameLogoUrl);
    const logoCombined = Promise.all([logoValid]);
    logoCombined.then(([logoValid]) => {
      if (logoValid) {
        this.gameLogoUrl = gameLogoUrl;
      }
    })
  }

  public handleQrCodeSelected(event: any) {
    this.qrCodeImage = event.target.files[0];
    if (this.qrCodeImage) {
      const reader = new FileReader();
      reader.readAsDataURL(this.qrCodeImage);
      reader.onload = () => {
        this.qrCodeImageUrl = reader.result as string;
      }
    }
  }

  public clearGameLogo() {
    this.gameLogoImage = null;
    this.gameLogoUrl = '';
  }

  public handleGameLogoSelected(event: any) {
    this.gameLogoImage = event.target.files[0];
    if (this.gameLogoImage) {

      const reader = new FileReader();
      reader.readAsDataURL(this.gameLogoImage);
      reader.onload = () => {
        this.gameLogoUrl = reader.result as string;
      };
    }
  }

  public handleThemeTypeChange(valueP: GameThemeType) {
    switch (valueP) {
      case GameThemeType.Light:
        this.toolbarColor = '#ffffff';
        this.iconColor = '#222222';
        break;
      case GameThemeType.Dark:
        this.toolbarColor = '#222222';
        this.iconColor = '#ffffff';
        break;
      default:
        this.toolbarColor = '#222222';
        this.iconColor = '#ffffff';
        break;
    }
  }

  public validateImage(srcUrlP: string): Promise<boolean> {
    // if the game does not have a provided qr code, then do not show it
    return new Promise<boolean>((resolve) => {
      const img = new Image();
      img.src = srcUrlP;
      img.onload = () => {
        resolve(true);
      };
      img.onerror = () => {
        resolve(false);
      };
    });
  }

  public uploadGameImage(uploadLogoRequestP: IUploadImageToAzure) {
    return this.apiService.uploadFile(`game/upload-cdn-image/${uploadLogoRequestP.gameId}/${uploadLogoRequestP.adminId}`, uploadLogoRequestP.image);
  }
}
